import React, { useEffect, useState } from "react";
import axios from "axios";
import API from "../../Utils/API";
import { useHistory } from "react-router-dom";
import axiosInstance from "../../Utils/axios";
import Cookies from "universal-cookie";

function SystemToken() {
  const cookies = new Cookies();
  let history = useHistory();
  useEffect(async () => {
  }, []);
  return <div></div>;
}

export default SystemToken;
